/* tslint:disable */
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ServiceProvider } from 'providers/service/service';
import { GenProvider } from 'providers/gen/gen';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {
  bsModal: BsModalRef;
  @ViewChild('frmModal') frmModal: ModalDirective;
  @ViewChild('audio') audio: ElementRef;
  iconCollapse: string = "fa fa-fw fa-toggle-off";
  isCollapsed: boolean = false;
  icononLine: string = "fa fa-fw fa-toggle-off";
  isonLine: boolean = false;
  parametros: any = {
    grupo: null,
    instancia : null
  };
  subscrib: any;
  alerta: any;
  isIcon = false;
  isMostraOnline = false;
  iconLed = "fa fa-fw fa-circle";
  sugestao = 0;
  pathNotificacao = '../../assets/sons/whatsapp.mp3'
  atendimento: number = 0;
  classificado: number;
  subscription: any;
  cliente: number;
  time: any;
  status = {
    accountStatus: null,
    connected: null,
    authenticated: null,
    battery: null,
    charging: null,
    charge: null,
    qrCode: null
  }
  isLog: {};
  whatscall: number;
  whatsSender: number;
  contrato: number;
  mensagem: number;
  chatSetor: number;
  ouvidoria: number;
  denuncia: number;
  path: any;
  contatoOnline: number;
  contatoOnlineDenuncia: number;
  isNotificacao: boolean = false;
  icononNotificacao = "fa fa-fw fa-toggle-off";
  isGravarPergunta: boolean = false;
  isonLineEmail: boolean;
  constructor(
    private service: ServiceProvider,
    private genProvider: GenProvider,
    private router: Router
  ) {

  }
  ngOnInit() {
    setTimeout(() => {
      this.parametros = this.genProvider.parametros;
      this.path = this.parametros.path.toUpperCase();
      if (this.parametros.nivel == '99') {
        this.isMostraOnline = true;
      } else {
        this.isMostraOnline = false;
      }
      if ((this.parametros.grupo == 'Atendimento') || (this.parametros.grupo == 'Administrador')) {
      }
      if ((this.parametros.grupo == 'Ouvidoria') || (this.parametros.grupo == 'Administrador')) {
      }
      this.onStart();
      setTimeout(() => {
        this.service.onStartEmail(true);
     //   this.onStatus();
    //  this.onStartEmail();
   //     this.onGravarPergunta();
   //     this.onLine();
   //     this.onStartNotificacao();
      }, 5000);
    }, 5000);

  }

  notificacaoStart(){
    let msg = "*Plataforma WhatsUp.*" + this.service.ctrl + "LOGIN DE INICIALIZAÇÃO"
      let formulario = {
      contato: '5591980333070',
      mensagem: msg
    };
    setTimeout(() => {
      this.service.enviarMsg(formulario);
    }, 5000);
  }
    onGravarPergunta(){
    if (this.parametros.nivel == '99') {
      this.isGravarPergunta = !this.isGravarPergunta;
    //  this.isGravarPergunta = this.isGravarPergunta ? "fa fa-fw fa-toggle-on" : "fa fa-fw fa-toggle-off";
      this.service.onGravarPergunta();
    }
  }

  onStart() {
    if (this.parametros.nivel == '99') {
      this.isonLine = !this.isonLine;
      this.icononLine = this.isonLine ? "fa fa-fw fa-toggle-on" : "fa fa-fw fa-toggle-off";
      this.service.onStart(this.isonLine);
    }

  }
  onStartNotificacao() {
    if (this.parametros.nivel == '99') {
      this.isNotificacao = !this.isNotificacao;
      this.icononNotificacao = this.isNotificacao ? "fa fa-fw fa-toggle-on" : "fa fa-fw fa-toggle-off";
      this.service.onBot();
    }
  }

  onLine() {
    this.genProvider.onGetfilter('whatsPost/', 'instanceId', this.parametros.instancia)
      .subscribe(
        data => {
          this.isIcon = true;
          this.iconLed = this.isIcon ? "fa fa-fw fa-circle" : "fa fa-fw fa-circle";
          setTimeout(() => {
            this.isIcon = false;
            this.iconLed = this.isIcon ? "fa fa-fw fa-circle" : "fa fa-fw fa-circle";
          }, 500);
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onLog() {
    this.service.onStartLog().then(res => {
      this.isLog = res;
    })
  }

  notificacao() {
    this.audio.nativeElement.play();
  }
  ngAfterViewInit() {
    // console.log(this.audio.nativeElement);
  }

  showModal() {
    this.frmModal.show();
  }

  hidedModal() {
    this.frmModal.hide();
  }
  onHoraAtual() {
    this.horaAtual().subscribe(res => {
      this.time = res
    })
  }

  onGetStatus() {
    this.temporizador().subscribe(res => {
       console.log ("status")
     //  this.onStatus();
    });
  }
  temporizador() {
    return (this.time = new Observable(observer => {
      setInterval(() => {
        observer.next(new Date().toString());
      }, 1000*60*5);
    }));
  }
  horaAtual() {
    return (this.time = new Observable(observer => {
      setInterval(() => {
        console.log(new Date().toString())
        observer.next(new Date().toString());
      }, 1000);
    }));
  }
  onStartEmail(){
    if (this.parametros.nivel == '99') {
      this.isonLineEmail = !this.isonLineEmail;
      this.service.onStartEmail(this.isonLineEmail);
    }
  }
  sendEmail(){
    let data = {
      contato: "paulospcoelho@gmail.com",
      assunto: "teste assunto",
      mensagem:"teste de envio de email"
    }
    this.service.onSendEmail(data);
  }
  loadEmail(){

    this.service.loadListEmail();
  }
  loadMidiaEmail(){
    let data = {
      url : "./attachment/HC/1-IMG-20220224-WA0037.jpeg",
      file: "IMG-20220224-WA0037.jpeg"
    }
    this.service.loadMidiaEmail(data);
  }
  onIntegrar(){
    this.service.onStartIntegracao();
  }
  onMenu(){
    this.service.onParametro();
    let c = {
    origem: "whatsapp",
    id_canal: "559180333070"
    }
    let contato =[]; 
    contato.push(c);
    this.service.onStartAtendimento(contato);
  }
}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/containers/full-layout/full-layout.component.ts